import React from "react";
import MenuDoctor from "./navDoctor/MenuDoctor";
import Home from "../public/Home";
import HeadBar from "../public/headBar/HeadBar";

export default function HomeDoctor() {
    return(
        <>
            <Home roleUser={'Medical'}/>
        </>
    )
}